import { createSignal } from "solid-js";
import { Field } from "./tovField";

export function AddTraitForm(props: {
  nextOrder: number;
  onAdd: (trait: {
    key: string;
    label: string;
    description: string;
    targetStrength: number;
    displayOrder: number;
  }) => void;
}) {
  const [key, setKey] = createSignal("");
  const [label, setLabel] = createSignal("");
  const [description, setDescription] = createSignal("");
  const [strength, setStrength] = createSignal(50);
  return (
    <form
      class="tov-panel"
      onSubmit={(event) => {
        event.preventDefault();
        if (!key() || !label() || !description()) return;
        props.onAdd({
          key: key(),
          label: label(),
          description: description(),
          targetStrength: strength(),
          displayOrder: props.nextOrder,
        });
        setKey("");
        setLabel("");
        setDescription("");
        setStrength(50);
      }}
    >
      <span class="tov-panel-title">Add trait</span>
      <div class="tov-form">
        <Field label="Key">
          <input
            class="tov-input"
            value={key()}
            placeholder="warmth"
            onInput={(event) => setKey(event.currentTarget.value)}
          />
        </Field>
        <Field label="Label">
          <input
            class="tov-input"
            value={label()}
            placeholder="Warmth"
            onInput={(event) => setLabel(event.currentTarget.value)}
          />
        </Field>
        <Field label="Description" grow>
          <input
            class="tov-input"
            value={description()}
            placeholder="How this trait shows up in copy"
            onInput={(event) => setDescription(event.currentTarget.value)}
          />
        </Field>
        <Field label="Strength">
          <input
            class="tov-input tov-input-num"
            type="number"
            min="0"
            max="100"
            value={strength()}
            onInput={(event) => setStrength(Number(event.currentTarget.value))}
          />
        </Field>
        <button type="submit" class="btn btn-primary">
          Add
        </button>
      </div>
    </form>
  );
}
